import type { PokerSiteId } from '@poker-stats/contracts';

const authController = 'auth';
const playersController = 'players';
const statisticsController = 'statistics';
const feedbackController = 'feedback';
const usersController = 'users';
const referralsController = 'referrals';
const parserErrorsController = 'parser-errors';
const analyticsController = 'analytics';

export const apiEndPoints = {
  auth: {
    user: `${authController}/user`,
    login: `${authController}/login`,
    logout: `${authController}/logout`,
    register: `${authController}/register`,
    confirm: `${authController}/confirm`,
    refresh: `${authController}/refresh`,
    changePassword: `${authController}/changePassword`,
    changeEmail: `${authController}/changeEmail`,
    reset: `${authController}/reset`,
  },
  players: {
    players: playersController,
    autopaste: `${playersController}/autopaste`,
    playerToChoose: `${playersController}/playerToChoose`,
  },
  statistics: {
    stats: `${statisticsController}/stats`,
    graph: `${statisticsController}/graphResults`,
    topPlayers: `${statisticsController}/topPlayers`,
  },
  feedback: {
    feedback: feedbackController,
  },
  users: {
    users: usersController,
    activate: `${usersController}/activate`,
    changeUserAvailablePokersiteIds: `${usersController}/changeUserAvailablePokersiteIds`,
    changeUserSubscription: `${usersController}/changeUserSubscription`,
    changeUserSubscriptionDate: `${usersController}/changeUserSubscriptionDate`,
    changeUserRoomsToSearch: `${usersController}/changeRoomsToSearch`,
    changeAutopasteRoomPriority: `${usersController}/changeAutopasteRoomPriority`,
  },
  referrals: {
    me: `${referralsController}/me`,
    payment: `${referralsController}/payment`,
    payout: `${referralsController}/payout`,
    admin: `${referralsController}/admin`,
    settings: `${referralsController}/settings`,
  },
  parserErrors: {
    parserErrors: parserErrorsController,
  },
  mining: {
    upload: (pokerSiteId: PokerSiteId) => `mining/${pokerSiteId}/upload`,
  },
  analytics: {
    overview: `${analyticsController}/overview`,
    rooms: `${analyticsController}/rooms`,
  },
};
